import { DependencyList, ReactNode } from "react";
import { usePageIntro } from "common/NewLook";

interface PageIntroActionsProps {
  actions: ReactNode;
  deps: DependencyList;
}

/**
 * Sets the new-look page intro actions while mounted. Rendered conditionally
 * so that shared wrappers (also used inside forms and drawers) don't clear an
 * intro configured by their page.
 */
const PageIntroActions = ({ actions, deps }: PageIntroActionsProps) => {
  usePageIntro({ actions }, deps);
  return null;
};

export default PageIntroActions;
